import reducer from './reducers';

import * as contactValidationSelectors from './selectors';
import * as contactValidationOperations from './operations';
import * as contactValidationTypes from './types';

export { contactValidationSelectors, contactValidationOperations, contactValidationTypes };

export default reducer;
